/**
 * Shared EN/PL localized text helpers — SoT for deterministic builders.
 * API re-export: api/src/utils/localizedText.js
 */

function L(en, pl) {
    return { en, pl };
}

function pickLocalized(value, lang) {
    if (!value) return '';
    if (typeof value === 'string') return value;
    return value[lang] || value.en || value.pl || '';
}

function locField(field) {
    if (!field) return L('', '');
    if (typeof field === 'string') return L(field, field);
    return L(field.en || field.pl || '', field.pl || field.en || '');
}

module.exports = {
    L,
    pickLocalized,
    locField,
};
